import React from 'react';
import { heritageTableData } from '../data/mock';
import { Utensils, Leaf, Globe } from 'lucide-react';

const HeritageTableSection = () => {
  return (
    <section id="fija-way" className="py-24 md:py-32 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Label */}
        <div className="text-center mb-16">
          <span className="font-lato text-[#D4AF37] uppercase tracking-[0.3em] text-sm">The FIJA Way</span>
        </div>

        {/* Content Grid - Image Left, Text Right */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative rounded-xl overflow-hidden shadow-2xl">
              <img
                src={heritageTableData.image}
                alt="The Heritage Table - Cultural Gourmet Dining"
                className="w-full h-[400px] md:h-[500px] object-cover"
              />
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A2B3C]/40 to-transparent" />
            </div>
            
            {/* Decorative frame */}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-l-2 border-t-2 border-[#D4AF37]" />
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-r-2 border-b-2 border-[#D4AF37]" />
            
            {/* Floating badge */}
            <div className="absolute -bottom-6 left-8 bg-[#1A2B3C] text-white px-6 py-4 rounded-lg shadow-xl">
              <div className="flex items-center gap-3">
                <Utensils className="w-5 h-5 text-[#D4AF37]" />
                <span className="font-playfair text-lg">The Heritage Table</span>
              </div>
            </div>
          </div>

          {/* Text Side */}
          <div className="lg:pl-8">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-px bg-[#D4AF37]" />
              <span className="font-lato text-[#D4AF37] uppercase tracking-[0.2em] text-xs">Cultural Catering</span>
            </div>

            <h2 className="font-playfair text-4xl md:text-5xl text-[#1A2B3C] mb-6 leading-tight">
              {heritageTableData.headline}
            </h2>

            <p className="font-lato text-[#1A2B3C]/70 text-lg leading-relaxed mb-8">
              {heritageTableData.body}
            </p>

            {/* Feature Points */}
            <div className="space-y-4 mb-8">
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#8DA399]/20 flex items-center justify-center">
                  <Leaf className="w-5 h-5 text-[#8DA399]" />
                </div>
                <span className="font-lato text-[#1A2B3C]/80">Fresh, locally-sourced ingredients</span>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-10 h-10 rounded-full bg-[#8DA399]/20 flex items-center justify-center">
                  <Globe className="w-5 h-5 text-[#8DA399]" />
                </div>
                <span className="font-lato text-[#1A2B3C]/80">Menus reflecting diverse cultural heritage</span>
              </div>
            </div>

            <button className="font-lato px-8 py-4 border-2 border-[#1A2B3C] text-[#1A2B3C] rounded hover:bg-[#1A2B3C] hover:text-white transition-all duration-300">
              View Sample Menu
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeritageTableSection;
